<div class="input-form">

  <mat-card class="mat-elevation-z0">
    <form (ngSubmit)="onSubmit()" [formGroup]="aeroInputForm" novalidate>

      <mat-card-header>
        <mat-card-subtitle *ngIf="unId">Change Request: <a routerLink='/change-request/edit/{{unId}}'>{{unName}}</a>
        </mat-card-subtitle>
        <mat-card-title>{{featureType}}: {{gmlname}}</mat-card-title>

        <!-- This fills the remaining space of the current row -->
        <span class="fill-remaining-space"></span>

        <span style="display: flex; align-items: center;">
          @if (state === 'existing' && enableValidation && !!unId) {
            <button color="primary" matTooltip="Validate" type="button" mat-icon-button (click)="validateFeature()">
              <mat-icon> <span class="material-symbols-outlined">fact_check</span> </mat-icon>
            </button>
            <button color="primary" matTooltip="Validation reports" type="button" mat-icon-button (click)="navigateToValidationReport()">
              <mat-icon> <span class="material-symbols-outlined">library_add_check</span> </mat-icon>
            </button>
          }
          <button type="button" mat-icon-button matTooltip="Assign allowed Editor" (click)="openDataproviderDialog()"
            *ngIf="state != 'new' && isAisReviewer()">
            <mat-icon color="primary" aria-label="Assign allowed Editor">
              lock
            </mat-icon>
          </button>
          <button type="button" mat-icon-button matTooltip="Decommission feature" [disabled]="isDisableDecommission()"
            (click)="decommission()" *ngIf="!readonly">
            <mat-icon color="warn" aria-label="decommission feature">
              delete
            </mat-icon>
          </button>
          <button type="button" mat-icon-button matTooltip="Annotations" [disabled]="readonly && !featureAnnotationProperty"
          (click)="showAnnotations? hideAnnotaion(): createAnnotation()">
            <mat-icon color="primary" aria-label="Annotations" 
            [ngClass]="{'disable':readonly && !featureAnnotationProperty, 'enable': featureAnnotationProperty}">note</mat-icon>
          </button>
          <button type="button" mat-icon-button (click)="openDialog()" matTooltip="Search another feature">
            <mat-icon color="primary" aria-label="Search another feature">search</mat-icon>
          </button>
          <button mat-icon-button type="submit" [disabled]="!aeroInputForm.dirty || !aeroInputForm.valid"
            matTooltip="Save" *ngIf="!readonly">
            <mat-icon color="primary" aria-label="Save">save</mat-icon>
          </button>
          <button type="button" mat-icon-button matTooltip="Revert to initial value"
            (click)="revert(); stopPropagation($event)" *ngIf="!readonly">
            <mat-icon color="primary" aria-label="Set property to nil">undo</mat-icon>
          </button>
          <!-- Close Form Btn -->
          <button color="primary" type="button" mat-icon-button
            matTooltip="Close" (click)="closeForm(); stopPropagation($event)" *ngIf="!readonly">
            <mat-icon aria-label="Set property to nil">close</mat-icon>
          </button>
          <!-- Close Form Confirmation Tpl -->
          <ng-template #closeFormDialogTpl>
            <h1 mat-dialog-title>Close AIXM Edit Form</h1>
            <div mat-dialog-content>
              <span>You have unsaved changes. Are you sure you want to leave from this page?</span>
            </div>
            <div mat-dialog-actions align="end">
              <button mat-button mat-dialog-close>Cancel</button>
              <button mat-button color="warn" [mat-dialog-close]="true">Close Form</button>
            </div>
          </ng-template>
        </span>
      </mat-card-header>

      <mat-divider></mat-divider>

      <div *ngIf="state != 'new' && beginPosition" style="padding:16px; margin-bottom: 1rem">
        <mat-label>Data valid from {{beginPosition}} to </mat-label>
        <span *ngIf="endPosition">{{endPosition}}</span>
        <span *ngIf="!endPosition">Until Further Notice</span>
        <div *ngIf="effectiveDate">
          <span>Changes effective {{effectiveDate}} </span>
          <span *ngIf="isTentative" style="font-size: 12px;">(tentative)</span>
        </div>
      </div>

      <!-- Metadata block for UN -->
       @if (selectedTimeslice() && !!unId) {
        <app-metadata-block [selectedTimeSlice]="selectedTimeslice()">
        </app-metadata-block>
      }

      <div *ngIf="showAnnotations" class="indented feature-annotations">
        <im-property-switch 
          [property]="annotationProperty" 
          [parentFormGroup]="aeroInputForm"
          [arrayName]="0 + '-annotations'"
          [readonly]="readonly">
        </im-property-switch>
      </div>

      <!-- Timeline -->
      <div class="time-slice-list" *ngIf="!unId">
        <im-time-slice-list [featureId]="featureId" (selectedTSEmitter)="getPropertiesWithSelectedTS($event)">
        </im-time-slice-list>
      </div>

      <!-- Metadata block for Data Browser -->
       @if (selectedTimeslice() && !unId) {
        <app-metadata-block [selectedTimeSlice]="selectedTimeslice()">
        </app-metadata-block>
      }
      
      <mat-card-content>
        <div *ngFor="let property of properties" class="form-row">
          <ng-container *ngIf="!isChoiceProperty(property.key)">
            <im-property-switch 
              *ngIf="properties[0]"
              [property]="property" 
              [properties]="properties"
              [parentFormGroup]="aeroInputForm" 
              [state]="state" 
              [tsId]="tsId"
              [readonly]="readonly"
              >
            </im-property-switch>
          </ng-container>
        </div>
      </mat-card-content>

      <mat-card-actions>
        <button mat-raised-button color="primary" class="example-btn-width-blue" *ngIf="!readonly" type="submit"
          [disabled]="!aeroInputForm.dirty || !aeroInputForm.valid">
          Save
        </button>
      </mat-card-actions>

    </form>
  </mat-card>
  <!-- <div *ngIf="payLoad" class="form-row">
    <strong>Saved the following values</strong>
    <hr>{{payLoad}}
  </div>
  <pre>group string:  {{groupString | json}}</pre> -->
</div>